import { isPopUp } from '@/api/user'
import { actionTypes } from '@/store'

export const getIsPopUp = async ({ callBack }) => {
    const res = await isPopUp()
    if (res?.code === 0) {
        callBack({ type: actionTypes.SET_FIRST_STRATE, payload: res?.data?.isFirst })
    }
}